import {Link, useLocation} from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "FirebaseSetup/auth";
import PageLoader from "Components/PageLoader";
import { NewPasswordForm } from "Features/Authentication";
import Box from "Components/Box";
import FlexRow from "Components/FlexRow";
import {useTranslation} from "react-i18next";
import AnotherSolutionIcon from "../Assets/SVG/AnotherSolutionIcon";


const AuthActions = () => {
    
    let query = new URLSearchParams(useLocation().search);
    let mode = query.get('mode');
    let oobCode = query.get('oobCode') ?? '';
    
    const { t } = useTranslation();

    const [codeValidated, setCodeValidated] = useState<boolean>(false);
    const [codeAccepted, setCodeAccepted] = useState<boolean>(false);
    
    useEffect(() => {
        if (mode === 'resetPassword' && !codeValidated) {
            auth.verifyPasswordResetCode(oobCode).then(() => {
                setCodeAccepted(true);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                setCodeValidated(true);
            })
        }
    }, [mode, oobCode, codeValidated]);
    
    if (!codeValidated) {
        return <PageLoader shown={true}><div></div></PageLoader>
    }
    
    return (
        <FlexRow className={"h-100"} justify={"center"} align={"center"}>
            <div style={{width: 400}}>
                <Box>
                    <AnotherSolutionIcon width={200} style={{paddingBottom: 20}} />
                    {codeAccepted && (
                        <NewPasswordForm oobCode={oobCode} />
                    )}
                    {!codeAccepted && (
                        <div>
                            <h3>{t('resetPasswordLinkExpired')}</h3>
                            <Link style={{all: 'unset'}} to={"/resetpassword"}>{t('resetpassword')}</Link>
                        </div>
                    )}
                </Box>
            </div>
        </FlexRow>
    )
}

export default AuthActions
